import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import PriceList from '../PriceList'
import { AppState } from '../../../../reducers'
import { Filters, FiltersBar, searchToFilters } from '../../../Utils/Filters/Filter'
import { FilterBrand, FilterPreorderStuff } from '../../../Utils/Filters'
import { useTranslation } from 'react-i18next'
import { Button, CircularProgress, Stack, Typography } from '@mui/material'
import { fetchPreorderProducts } from '../../../../actions/preorder/preorderProductList'
import { PreorderProductListState } from '../../../../reducers/preorder/preorderProductList'
import { ProductBrandListState } from '../../../../reducers/product/productBrandList'
import { ProductSectionListState } from '../../../../reducers/product/productSectionList'
import { ProductGroupListState } from '../../../../reducers/product/productGroupList'
import { ProductSubgroupListState } from '../../../../reducers/product/productSubgroupList'
import { fetchAllProductBrands } from '../../../../actions/product/productBrandList'
import { fetchAllProductGroups } from '../../../../actions/product/productGroupList'
import { fetchAllProductSections } from '../../../../actions/product/productSectionList'
import { fetchAllProductSubgroups } from '../../../../actions/product/productSubgroupList'
import { ProductRelations } from '../../Preorders/PreordersList'
import { getToken } from '../../../../utils/fetchApi'
import { ProductListState } from '../../../../reducers/product/productList'
import { fetchAllProducts } from '../../../../actions/product/productList'
import { InfoCurrentPriceListState } from '../../../../reducers/infoCurrentPriceList'
import { fetchInfoCurrentPriceList } from '../../../../actions/currentPriceList'
import moment from 'moment'
import { FiletypePdf, FiletypeXls } from 'react-bootstrap-icons'

interface Props {
  fullInfo?: boolean
  preorderProducts: PreorderProductListState
  productBrandsList: ProductBrandListState
  productSectionsList: ProductSectionListState
  productGroupsList: ProductGroupListState
  productSubgroupsList: ProductSubgroupListState
  productList: ProductListState
  currentPriceList: InfoCurrentPriceListState
}

const ProductPriceList: React.FC<Props> = ({ preorderProducts, productBrandsList, productSectionsList, productGroupsList, productSubgroupsList, productList, currentPriceList }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation(['product', 'others', 'preorder'])
  const [selectedBrand, setSelectedBrand] = useState<number>(0)
  const [selectedSection, setSelectedSection] = useState<number>(0)
  const [selectedGroup, setSelectedGroup] = useState<number>(0)
  const [downloadingCatalog, setDownloadingCatalog] = useState<boolean>(false)

  //const [selectedSubgroup, setSelectedSubgroup] = useState<number>(0)

  const [productRelations, setProductRelations] = useState<ProductRelations[]>([])

  const initPreordersFilters: Filters = {
    brand: '',
    section: '',
    group: '',
    subgroup: ''
  }

  useEffect(() => {
    dispatch(fetchAllProductBrands())
    dispatch(fetchAllProductSections())
    dispatch(fetchAllProductGroups())
    dispatch(fetchAllProductSubgroups())
    dispatch(fetchAllProducts())
    dispatch(fetchInfoCurrentPriceList())
  }, [dispatch])

  useEffect(() => {
    dispatch(fetchPreorderProducts(history.location.search))
  }, [dispatch, history.location.search])

  useEffect(() => {
    const constructRelations = () => {
      let relations: ProductRelations[] = [];
      productList.products?.forEach(p => {
        if (!relations.some(item => item.brandId === p.brandId && item.sectionId === p.sectionId && item.groupId === p.groupId && item.subgroupId === p.subgroupId))
          relations.push(({ brandId: p.brandId, sectionId: p.sectionId, groupId: p.groupId, subgroupId: p.subgroupId }))
      })
      return relations
    }
    if (!productList.isFetching)
      setProductRelations(constructRelations())
  }, [productList, productList.isFetching])

  useEffect(() => {
    const filters = searchToFilters(history.location.search)
    setSelectedBrand(filters.brand ? parseInt(filters.brand) : 0)
    setSelectedSection(filters.section ? parseInt(filters.section) : 0)
    setSelectedGroup(filters.group ? parseInt(filters.group) : 0)
    //setSelectedSubgroup(filters.subgroup ? parseInt(filters.subgroup) : 0)
  }, [history.location.search])

  /*
    const filterRelations = () => productRelations.filter(r => (selectedBrand ? r.brandId === selectedBrand : true) &&
      (selectedSection ? r.sectionId === selectedSection : true) &&
      (selectedGroup ? r.groupId === selectedGroup : true) &&
      (selectedSubgroup ? r.subgroupId === selectedSubgroup : true))
  
    const brandList = () => productBrandsList.productBrands?.filter(b => filterRelations().some(r => b.id === r?.brandId))
    const sectionList = () => productSectionsList.productSections?.filter(s => filterRelations().some(r => s.id === r?.sectionId))
    const groupList = () => productGroupsList.productGroups?.filter(g => filterRelations().some(r => g.id === r?.groupId))
    const subgroupList = () => productSubgroupsList.productSubgroups?.filter(sg => filterRelations().some(r => sg.id === r?.subgroupId))
  */

  const filterRelations = () => productRelations.filter(r => (selectedBrand ? r.brandId === selectedBrand : true) &&
    (selectedSection ? r.sectionId === selectedSection : true) &&
    (selectedGroup ? r.groupId === selectedGroup : true))

  const brandList = () => productBrandsList.productBrands

  const sectionList = () => productSectionsList.productSections

  const groupList = () => productGroupsList.productGroups?.filter(g => filterRelations().some(r => g.id === r?.groupId))

  const subgroupList = () => {
    // Filtrar las relaciones según los filtros
    const filteredRelations = productRelations.filter(
      r =>
        (selectedBrand ? r.brandId === selectedBrand : true) &&
        (selectedSection ? r.sectionId === selectedSection : true) &&
        (selectedGroup ? r.groupId === selectedGroup : true)
    );

    // Filtrar los subgrupos basados en las relaciones filtradas
    const subgroups = productSubgroupsList.productSubgroups?.filter(sg =>
      filteredRelations.some(r => r.subgroupId === sg.id)
    ) || [];

    return subgroups;
  };

  const clearDependentFilters = (filters: Filters, name: string) => {
    return {
      ...filters,
      section: name !== 'section' ? '' : filters.section,  // Limpia el filtro de sección
      group: name !== 'group' ? '' : filters.group,    // Limpia el filtro de grupo
      subgroup: '', // Limpia el filtro de subgrupo
    };
  };

  const DownloadPriceListButton = () => {
    const canShare = () => navigator.canShare?.()
    const handleDownloadAndShare = async (fileType: string) => {

      const url = `${process.env.REACT_APP_API_URL}/dlPriceList?access_token=${getToken()}&fileType=${fileType}`

      try {

        // 1. Fetch modificado para evitar la descarga automática
        const response = await fetch(url);

        // 2. Obtener el blob y el nombre del archivo del header
        const blob = await response.blob();
        const contentDisposition = response.headers.get('Content-Disposition');
        const fileNameMatch = contentDisposition?.match(/filename=(.+)/);

        const dataPriceList = `000${currentPriceList.currentOnePriceList?.codigo_listadeprecios}`.slice(-3)

        const fileName = fileNameMatch ? fileNameMatch[1] : `lista_de_precios-${moment().tz("America/Argentina/Buenos_Aires").format('YYYY-MM-DD')}-Lista-${dataPriceList}-industrias_saladillo.${fileType}`;

        // 3. Crear el File con el tipo MIME correcto
        const file = new File([blob], fileName, {
          type: fileType === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // Verificar específicamente si se puede compartir el archivo
        if (navigator.share && navigator.canShare?.({ files: [file] })) {
          await navigator.share({
            files: [file],
            title: t('downloadDL', { ns: 'others' }),
            text: t('shareDLText', { ns: 'others' }) || 'Compartir lista de precios'
          });
          return
        } else {
          window.open(
            url,
            '_blank'
          );
        }
      } catch (error) {
        console.error('Error al descargar/compartir:', error);
        // 4. Fallback final (tu método original))
        window.open(
          url,
          '_blank'
        );
      }
    };

    const handleCatalogDownloadAndShare = async (fileType: string) => {
      setDownloadingCatalog(true)
      const url = `${process.env.REACT_APP_API_URL}/dlCatalog?access_token=${getToken()}&fileType=${fileType}`

      try {

        // 1. Fetch modificado para evitar la descarga automática
        const response = await fetch(url);

        // 2. Obtener el blob y el nombre del archivo del header
        const blob = await response.blob();
        const contentDisposition = response.headers.get('Content-Disposition');
        const fileNameMatch = contentDisposition?.match(/filename=(.+)/);

        const fileName = fileNameMatch ? fileNameMatch[1] : `catalogo-general-${moment().tz("America/Argentina/Buenos_Aires").format('YYYY-MM-DD')}-industrias_saladillo.${fileType}`;

        // 3. Crear el File con el tipo MIME correcto
        const file = new File([blob], fileName, {
          type: fileType === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        setDownloadingCatalog(false)

        // Verificar específicamente si se puede compartir el archivo
        if (navigator.share && navigator.canShare?.({ files: [file] })) {
          await navigator.share({
            files: [file],
            title: t('downloadCatalogDL', { ns: 'others' }),
            text: t('shareCatalogDLText', { ns: 'others' }) || 'Compartir Catalogo'
          });
          return
        } else {
          setDownloadingCatalog(false)
          window.open(
            url,
            '_blank'
          );
        }
      } catch (error) {
        console.error('Error al descargar/compartir:', error);
        // 4. Fallback final (tu método original))
        setDownloadingCatalog(false)
        window.open(
          url,
          '_blank'
        );
      }
    };

    return (
      <Stack display="flex" flexDirection='row' justifyContent="flex-end" padding="10px" paddingTop="20px">
        <Button
          id="downloadCatalog"
          aria-label="downloadCatalog"
          size='large'
          style={{ textTransform: 'none', marginRight: '30px' }}
          onClick={() => handleCatalogDownloadAndShare('pdf')}
        >
          {t(canShare() ? 'shareCatalogDLText' : 'downloadCatalogDL', { ns: 'others' })}&nbsp;&nbsp;<FiletypePdf size={30} />
        </Button>
        <Button
          id="download"
          aria-label="download"
          size='large'
          style={{ textTransform: 'none', marginRight: '30px' }}
          onClick={() => handleDownloadAndShare('pdf')}
        >
          {t(canShare() ? 'shareDLText' : 'downloadDL', { ns: 'others' })}&nbsp;&nbsp;<FiletypePdf size={30} />
        </Button>
        <Button
          id="download"
          aria-label="download"
          size='large'
          style={{ textTransform: 'none' }}
          onClick={() => handleDownloadAndShare('xls')}
        >
          {t('downloadDL', { ns: 'others' })}&nbsp;&nbsp;<FiletypeXls size={30} />
        </Button>
      </Stack>
    );
  }


  return (
    <Stack style={{ height: 'calc(100% - var(--header-height)' }}>
      {!downloadingCatalog &&
      <FiltersBar
        defaultFilters={initPreordersFilters}
        noControlFilters
        resetOnChange={["brand", "section", 'group']}
        clearDependentFilters={clearDependentFilters}
      >
        <FilterBrand name='brand' label={t("brands")} style={{ maxWidth: "300px", width: "300px", marginRight: "10px" }}
          menuItems={brandList()} />

        <FilterPreorderStuff name="section" label={t("sections")} style={{ maxWidth: "200px", width: "200px", marginRight: "10px" }}
          menuItems={sectionList()} />

        <FilterPreorderStuff name="group" label={t("groups")} style={{ maxWidth: "350px", width: "350px", marginRight: "10px" }}
          menuItems={groupList()} />

        <FilterPreorderStuff name="subgroup" label={t("products", { ns: 'preorder' })} style={{ maxWidth: "350px", width: "350px", marginRight: "10px" }}
          menuItems={subgroupList()} />
      </FiltersBar>}
      {!downloadingCatalog &&
      <PriceList
        priceList={currentPriceList.currentOnePriceList?.codigo_listadeprecios || 0}
        rows={(preorderProducts.preorderProducts || []).map(s => ({ data: s }))}
        loading={preorderProducts.isFetching}
        pagination={preorderProducts.pagination || undefined}
      />}

      {!downloadingCatalog &&<DownloadPriceListButton />}

      {downloadingCatalog &&
        <div style={{ display: 'flex', height:'100%', flexDirection:"column", alignContent: 'center', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="h5">{t('wait', { ns: 'others'})}</Typography>
          <CircularProgress size={40} />
        </div>
      }

    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  productList: state.productList,
  preorderProducts: state.preorderProductList,
  productBrandsList: state.productBrandList,
  productSectionsList: state.productSectionList,
  productGroupsList: state.productGroupList,
  productSubgroupsList: state.productSubgroupList,
  currentPriceList: state.infoCurrentPriceList
})

export default connect(mapStateToProps, null)(ProductPriceList)